/**
 * Created by apple on 2019/6/24.
 */

// import Home from '@/views/Home'
// import Intro from '@/views/detail/Intro'
// import Contact from '@/views/detail/Contact'
// import Dig from '@/views/detail/Dig'
// import Info from '@/views/detail/Info'
// 按需加载
const Home = resolve => require(['../views/Home.vue'], resolve)
const Intro = resolve => require(['../views/detail/Intro.vue'], resolve)
const Contact = resolve => require(['../views/detail/Contact.vue'], resolve)
const Dig = resolve => require(['../views/detail/Dig.vue'], resolve)
const Info = resolve => require(['../views/detail/Info.vue'], resolve)

export default [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      keepAlive: true // 不需要缓存
    }
  },
  {
    path: '/intro',
    name: 'Intro',
    component: Intro
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/dig',
    name: 'Dig',
    component: Dig
  },
  {
    path: '/info',
    name: 'Info',
    component: Info
  }
]



// WEBPACK FOOTER //
// ./src/router/routers.js